module.exports = __webpack_public_path__ + "media/images/3-cd18b8aae476864ebb9a90010841e6fc.jpg";